import React from 'react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { SPONSOR_FIELDS } from './sponsorFields';
import SponsorFormField from './SponsorFormField';

const FIELD_GRID_STYLE = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '0.75rem',
};

const CANCEL_BTN_STYLE = {
  background: 'transparent',
  border: '1px solid #444',
  color: '#ccc',
};

const SponsorFormModal = ({ sponsor, onChange, onSave, onCancel }) => {
  const isEdit = Boolean(sponsor.id);
  const handleField = (name) => (val) => onChange({ ...sponsor, [name]: val });

  return (
    <Card style={{ marginBottom: '1rem' }}>
      <CardHeader>
        <CardTitle>{isEdit ? 'Edit Sponsor' : 'Add New Sponsor'}</CardTitle>
      </CardHeader>
      <CardContent>
        <div style={FIELD_GRID_STYLE}>
          {SPONSOR_FIELDS.map((field) => (
            <SponsorFormField
              key={field.name}
              field={field}
              value={sponsor[field.name]}
              onChange={handleField(field.name)}
            />
          ))}
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
          <Button onClick={onSave} className="send-email-btn" data-testid="save-sponsor-btn">
            {isEdit ? 'Update Sponsor' : 'Add Sponsor'}
          </Button>
          <Button onClick={onCancel} className="import-btn" style={CANCEL_BTN_STYLE}>
            Cancel
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SponsorFormModal;
